/**
 * Project role identifiers used for role-based UI visibility.
 *
 * Use with the *ocpHasProjectRole directive:
 *   <button hlmBtn *ocpHasProjectRole="Roles.Admin" type="button">Admin action</button>
 *   <button hlmBtn *ocpHasProjectRole="[Roles.Admin, Roles.Editor]" type="button">
 *     Shared action
 *   </button>
 */
export const Roles = {
  Admin: 'admin',
  Editor: 'editor',
} as const;

export type ProjectRole = (typeof Roles)[keyof typeof Roles];
